import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ContentProvider } from "@/context/ContentContext";
import Layout from "@/components/Layout";
import Loader from "@/components/Loader";

import Home from "@/pages/Home";
import WhatsIncluded from "@/pages/WhatsIncluded";
import Events from "@/pages/Events";
import Gallery from "@/pages/Gallery";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Reservations from "@/pages/Reservations";
import Waiver from "@/pages/Waiver";
import Privacy from "@/pages/Privacy";
import PaymentResult from "@/pages/PaymentResult";
import GiftCardResult from "@/pages/GiftCardResult";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

export default function App() {
  return (
    <AuthProvider>
      <ContentProvider>
        <BrowserRouter>
          <Loader />
          <Toaster
            position="top-center"
            toastOptions={{
              style: { background: "rgba(15,15,22,0.9)", color: "#fff", border: "1px solid rgba(255,255,255,0.12)", backdropFilter: "blur(12px)" },
            }}
          />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/whats-included" element={<WhatsIncluded />} />
              <Route path="/events" element={<Events />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/reservations" element={<Reservations />} />
              <Route path="/waiver" element={<Waiver />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/gift-cards/success" element={<GiftCardResult variant="success" />} />
              <Route path="/gift-cards/cancel" element={<GiftCardResult variant="cancel" />} />
              <Route path="/reservations/success" element={<PaymentResult variant="success" />} />
              <Route path="/reservations/cancel" element={<PaymentResult variant="cancel" />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
      </ContentProvider>
    </AuthProvider>
  );
}
